"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableFiltersContainer = exports.LoadMoreButtonContainer = exports.StyledRightAlignedTableCell = exports.StyledHeaderContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledHeaderContainer = styled_components_1.default.div `
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
`;
exports.StyledRightAlignedTableCell = styled_components_1.default.div `
  display: flex;
  justify-content: flex-end;
`;
exports.LoadMoreButtonContainer = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  padding: 1rem;
  width: 100%;
`;
exports.TableFiltersContainer = styled_components_1.default.div `
  padding: 1rem;
  display: flex;

  > div {
    flex: 1;
  }
`;
